import styled from 'styled-components';
import { ReactSVG } from 'react-svg';

import { solidBlack0 } from '@spotify-internal/encore-web';

export const Icon = styled(ReactSVG)`
  color: ${props => props.color || solidBlack0};
`;
